// @flow

import styled, { css } from 'styled-components';

export const Text = styled.p`
  font-family: ${props => props.theme.fontFamily.sansSerif};
  color: ${props => props.theme.colors.secondaryGray[1]};
  ${props => props.flavor === 'display' && css`
    font-family: ${props => props.theme.fontFamily.display};
  `}
`;
